/**
 * Project : workspace
 * File    : Notifications.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package native.notifications

/**
 * Represents the notifications class.
 */

class Notifications {
    val pushNotifications = PushNotifications.shared()
}